"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertBase64ToBlob = convertBase64ToBlob;
exports.getResizedImage = getResizedImage;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function generateImageFromFile(file) {
  return new Promise(function (resolve, reject) {
    var image = document.createElement('img');
    if (file.type.match('image.*')) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (event) {
        if (event.target.readyState === FileReader.DONE) {
          image.src = event.target.result;
          resolve(image);
        }
      };
      reader.onerror = function () {
        return reject(new Error('An error has occurred while processing the image'));
      };
    } else {
      reject(new Error('File must be an image'));
    }
  });
}
function convertBase64ToBlob(dataURI) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
  var byteString = atob(dataURI.split(',')[1]);
  var buffer = new ArrayBuffer(byteString.length);
  var intArray = new Uint8Array(buffer);
  for (var i = 0; i < byteString.length; i += 1) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([buffer], {
    type: type
  });
}
function getResizedImage(_x) {
  return _getResizedImage.apply(this, arguments);
}
function _getResizedImage() {
  _getResizedImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(file) {
    var width,
      height,
      canvas,
      image,
      canvasContext,
      imageSize,
      left,
      top,
      base64Image,
      _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          width = _args.length > 1 && _args[1] !== undefined ? _args[1] : 100;
          height = _args.length > 2 && _args[2] !== undefined ? _args[2] : 100;
          canvas = document.createElement('canvas');
          _context.next = 5;
          return generateImageFromFile(file);
        case 5:
          image = _context.sent;
          canvasContext = canvas.getContext('2d');
          canvasContext.canvas.width = width;
          canvasContext.canvas.height = height;
          imageSize = Math.min(image.width, image.height); // Do not resize if img is smaller than target
          if (!(imageSize < Math.min(width, height))) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", file);
        case 12:
          left = (image.width - imageSize) / 2;
          top = (image.height - imageSize) / 2;
          canvasContext.drawImage(image, left, top, imageSize, imageSize, 0, 0, canvasContext.canvas.width, canvasContext.canvas.height);
          base64Image = canvas.toDataURL('image/png');
          return _context.abrupt("return", convertBase64ToBlob(base64Image));
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getResizedImage.apply(this, arguments);
}
//# sourceMappingURL=images.js.map